import { render, staticRenderFns } from "./VerticalPoolElement.vue?vue&type=template&id=48c2ae94&scoped=true&"
import script from "./VerticalPoolElement.vue?vue&type=script&lang=js&"
export * from "./VerticalPoolElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c2ae94",
  null
  
)

export default component.exports